// Mirrors the classic /user/:uuid (a uuid or a username)
export default {
  path: '/v5/user/:uuid',
  name: 'V5_profile',
  component: () => import('./ProfilePage.vue'),
};
